import styled from '@emotion/styled';
import { Col, Tabs } from 'antd';

const { TabPane } = Tabs;

export const StyledTabPane = styled(TabPane)`
  outline: none;
`;

export const DeleteCol = styled(Col)`
  margin-right: ${props => props.theme.spacing.regular};
`;
